import { createContext, useContext, useState, useEffect, useMemo } from 'react';
import { SITE_CONFIG } from '../config/site';
import {
  palettes,
  getPaletteById,
  applyPaletteToDocument,
  buildColorsFromPalette,
  PALETTE_STORAGE_KEY,
} from '../constants/palettes';

const PaletteContext = createContext(null);

export function PaletteProvider({ children }) {
  // Palette is fixed via src/config/site.js - no user-facing selector.
  const [paletteId, setPaletteIdState] = useState(() =>
    palettes[SITE_CONFIG.paletteId] ? SITE_CONFIG.paletteId : 'lime'
  );

  const palette = useMemo(() => getPaletteById(paletteId), [paletteId]);

  useEffect(() => {
    applyPaletteToDocument(palette);
    localStorage.setItem(PALETTE_STORAGE_KEY, paletteId);
  }, [palette, paletteId]);

  const setPaletteId = (id) => {
    if (!palettes[id]) return;
    applyPaletteToDocument(getPaletteById(id));
    localStorage.setItem(PALETTE_STORAGE_KEY, id);
    setPaletteIdState(id);
  };

  return (
    <PaletteContext.Provider value={{ paletteId, setPaletteId, palette }}>
      {children}
    </PaletteContext.Provider>
  );
}

export function usePalette() {
  const ctx = useContext(PaletteContext);
  if (!ctx) {
    throw new Error('usePalette must be used within PaletteProvider');
  }
  return ctx;
}

export function usePaletteColors() {
  const { palette } = usePalette();
  return useMemo(() => buildColorsFromPalette(palette), [palette]);
}
